export function range(start: number, end: number): number[] {
  const itemsAmount = Math.abs(start - end);
  const _range = Array.from({ length: itemsAmount }, (_, index) => index);

  if (start < end) {
    return _range.map(item => item + start);
  }

  return _range.map((_, index) => start - index);
}
